<template>
  <div style="padding-bottom: 40px" v-if="body_show">
    <div class="cep61_top">
      <h1 class="text-ellipsis">{{data.headtitle}}</h1>
      <h2>测试者：{{data.nickname}}</h2>
      <h3>{{data.ctime}}</h3>
    </div>
    <!-- <div id="dimension" class="dimension"></div> -->
    <div>
      <div class="cep_main" v-for="(item,index) in data.report" :key="index" v-if="item.type == 'block'">
        <div v-for="(itm,idx) in item.content" :key="idx">
          <div v-if="itm.type == 'explain'">
            <div class="h_spe">测评说明</div>
            <div class="h_p" v-html="Trim(itm.content)"></div>
          </div>
          <div class="h_1" v-if="itm.type == 'title1'">{{itm.content}}</div>
          <div class="h_2" v-if="itm.type == 'title2'"><span></span>{{itm.content}}</div>
          <div v-if="itm.type == 'chart'">
            <!-- 柱状图 -->
            <v-chart :forceFit="true" v-if="itm.chart.type=='0'" :plotBackground="plotBackground" style="margin: 0 20px;margin-bottom: 30px" padding="auto" :height="height" :data="itm.chart.data" :scale="scale">
              <v-tooltip />
              <v-axis :dataKey="axis1Opts.dataKey" :line="axis1Opts.line" :tickLine="axis1Opts.tickLine" :label="axis1Opts.label" />
              <v-axis :dataKey="axis2Opts.dataKey" :line="axis2Opts.line" :tickLine="axis2Opts.tickLine" :label="axis2Opts.label" />
              <v-bar position="name*score" :color="color" />
            </v-chart>
            <!-- 折线图 -->
            <v-chart :forceFit="true" v-else-if="itm.chart.type==='1'" :plotBackground="plotBackground" style="margin: 0 20px;margin-bottom: 30px" padding="auto" :height="height" :data="itm.chart.data" :scale="scale">
              <v-tooltip />
              <v-axis :dataKey="axis1Opts.dataKey" :line="axis1Opts.line" :tickLine="axis1Opts.tickLine" :label="axis1Opts.label" />
              <v-axis :dataKey="axis2Opts.dataKey" :line="axis2Opts.line" :tickLine="axis2Opts.tickLine" :label="axis2Opts.label" />
              <v-line position="name*score" :color="color" :size="2" />
              <v-point position="name*score" :color="color" :size="4" shape="circle" />
            </v-chart>
            <!-- 仪表盘 -->
            <v-chart :forceFit="true" v-else-if="itm.chart.type =='2'" style="margin: 0 20px;margin-bottom: 30px" padding="auto" :height="height" :data="itm.chart.data" :scale="scale1">
              <v-coord type="polar" :startAngle="-202.5" :endAngle="22.5" :radius="0.75"></v-coord>
              <v-axis dataKey="score" :zIndex="2" :line="null" :label="axisLabel" :subTickCount="4" :subTickLine="axisSubTickLine" :tickLine="axisTickLine" :grid="null"></v-axis>
              <v-axis dataKey="1" :show="false"></v-axis>
              <v-series gemo="point" position="score*1" shape="pointer" color="#2EB6A8" :active="false"></v-series>
              <v-guide type="arc" :zIndex="0" :top="false" :start="[0,0.945]" :end="[100,0.945]" :vStyle="arcGuide1Style"></v-guide>
              <v-guide type="arc" :zIndex="1" :start="arcGuide2Start" :end="[itm.chart.data[0].score, 0.945]" :vStyle="arcGuide2Style"></v-guide>
              <v-guide type="html" :position="htmlGuidePosition" :html="htmlGuideHtml1 + itm.chart.data[0].name + htmlGuideHtml2 + itm.chart.data[0].score + '</p></div>'"></v-guide>
            </v-chart>

            <!-- 雷达图 :forcefit -->
            <v-chart :force-fit="true" v-else-if="itm.chart.type=='3'" :plotBackground="plotBackground" style="margin: 0;margin-bottom: 30px;" height="250" padding="auto" :data="itm.chart.data" :scale="scale">
              <v-tooltip />
              <v-axis :dataKey="axis1Opts.dataKey" :line="axis1Opts.line" :tickLine="axis1Opts.tickLine" :grid="axis1Opts.grid" />
              <v-axis :dataKey="axis2Opts.dataKey" :line="axis2Opts.line" :tickLine="axis2Opts.tickLine" :grid="axis2Opts.grid" />
              <v-legend dataKey="dvTransform" marker="circle" :offset="30" />
              <v-coord type="polar" :radius="0.8" />
              <v-line position="name*score" :color="color" :size="2" />
              <v-point position="name*score" :color="color" :size="4" shape="circle" />
              <!-- v-area不写就是线条，写就是块级 -->
              <v-area position="name*score" :color="color" />
            </v-chart>
           <!-- 条形图 -->
            <v-chart :forceFit="true" v-else-if="itm.chart.type=='4'" :plotBackground="plotBackground" style="margin: 0 20px;margin-bottom: 30px" padding="auto" :height="height" :data="itm.chart.data">
              <v-coord type="rect" direction="LB" />
              <v-tooltip />
              <v-axis dataKey="name" :label="label" />
              <v-axis dataKey="score" :label="label" />
              <v-bar position="name*score" :color="color" />
            </v-chart>
          </div>
          <div class="h_results" v-if="itm.type == 'results_block'">
            <h2 v-for="(it,ix) in itm.content" :key="ix">{{it.before}}<span>{{it.result}}</span>{{it.after}}</h2>
          </div>
          <div class="h_3" v-if="itm.type == 'title3'">{{itm.content}}</div>
          <div class="h_p" v-if="itm.type == 'text'">{{itm.text}}</div>
          <img :src="itm.poster" class="h_img" v-if="itm.type == 'posters'" alt="" />
          <img :src="show_market?itm.after:itm.before" class="h_img" v-if="itm.type == 'share'" alt="" />
        </div>
      </div>
    </div>
    <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  ext_evaluation_report,
} from "@/api/measurement";
import {
  getStorage,
  setStorage,
  isMain
} from "@/utils/tools";
import {
  shareCon
} from "@/utils/wxconfig";
import {
  Dialog
} from 'vant';
import Viser from 'viser-vue';
import DataSet from '@antv/data-set';
import {
  registerShape
} from 'viser-vue';
Vue.use(Viser);

export default {
  data() {
      return {
        body_show: false,
        data: {},
        isShow: false,
        qrcode: '',
        fl_group: [],
        type_obj: {
          headtitle: ""
        },
        show_market: false,
        height: 300,
        color: '#2EB6A8',
        // 仪表盘
        axisSubTickLine: {
          length: -8,
          stroke: '#ccc',
          strokeOpacity: 1,
        },
        axisTickLine: {
          length: -17,
          stroke: '#ccc',
          strokeOpacity: 1,
        },
        // arcGuide1Start: [0, 0.945],
        arcGuide1Style: {
          stroke: '#ccc',
          lineWidth: 18,
        },
        arcGuide2Start: [0, 0.945],
        arcGuide2End: [],
        arcGuide2Style: {
          stroke: '#2EB6A8',
          lineWidth: 18,
        },
        htmlGuidePosition: ['50%', '85%'],
        htmlGuideHtml: '',
        // 条形图
        label: {}
      }
    },
    mounted() {
      let path = this.$route.path;
      let show_market = getStorage(path, 'show_ceping') || '';
      if (show_market == 'show') {
        this.show_market = true;
      }
    },
    methods: {
      set_show_market() {
        setStorage(this.$route.path, 'show_ceping', 'show');
        this.show_market = true;
      },
      Trim(str) {
        return str.replace(/\n/g, '<br />');
      },
      // reset() {
      //   let q = this.$route.query;
      //   Dialog.confirm({
      //     title: '重新测评',
      //     message: '您确认要重测吗？'
      //   }).then(() => {
      //     evaluation_reset({
      //       eid: q.eid,
      //       order_id: q.order_id,
      //     })
      //       .then((data) => {
      //         this.$router.push({
      //           path:"/ceping",
      //           query: {eid: q.eid, order_id: order_id: q.order_id},
      //         })
      //       })
      //   }).catch(() => {
      //     // on cancel
      //   });
      // },
      pullData() {
        let q = this.$route.query;
        ext_evaluation_report({
            eid: q.eid,
            order_id: q.order_id,
          })
          .then((data) => {
            if (data.code != '10002') {
              document.title = data.headtitle;
              this.body_show = true;
              this.data = data;
              this.qrcode = data.qrcode;
              for (let arg of data.report) {
                if (arg.type == 'block') {
                  for (let arg1 of arg.content) {
                    if (arg1.type == 'chart') {
                      if (arg1.chart.type == 0) {
                        this.histogramChart();
                      } else if (arg1.chart.type == 1) {
                        this.lineChar();
                      } else if (arg1.chart.type == 2) {
                        this.dashboardChart();
                      } else if (arg1.chart.type == 3) {
                        this.radarChart();
                      } else if (arg1.chart.type == 4) {
                        this.barChart();
                      }
                    }
                  }
                }
              };
              // if (this.data.need_subscribe && !this.data.subscribe) {
              //   this.isShow = true;
              // };
              // 给wxconfig传对象
              this.type_obj.headtitle = data.headtitle;

              shareCon("ceping", this, this.type_obj);
            } else {
              if(data.msg=='测评未完成'){
                // 没有完成测评
                this.$router.push({
                  path:"/ext_ceping",
                  query: {eid: q.eid, order_id: q.order_id,}
                })
              }else{
                this.$toast(data.data.msg || data.msg || '请求失败');
                return
              }
            }

          })
      },
      // 仪表盘
      dashboardChart() {
        //   this.chartDatadash = arr;
        this.htmlGuideHtml1 = '<div style="width: auto;text-align: center;"><p style="font-size: 18px;color: #545454;margin: 0;">'
        this.htmlGuideHtml2 = '</p><p style="font-size: 18px;color: #2EB6A8;margin: 0;">'
        registerShape('point', 'pointer', {
          draw(cfg, container) {
            let point = cfg.points[0];
            point = this.parsePoint(point);
            const center = this.parsePoint({
              x: 0,
              y: 0,
            });
            container.addShape('line', {
              attrs: {
                x1: center.x,
                y1: center.y,
                x2: point.x,
                y2: point.y + 15,
                stroke: cfg.color,
                lineWidth: 5,
                lineCap: 'round',
              }
            });
            return container.addShape('circle', {
              attrs: {
                x: center.x,
                y: center.y,
                r: 9.75,
                stroke: cfg.color,
                lineWidth: 4.5,
                fill: '#fff',
              }
            });
          }
        });
        this.scale1 = [{
          dataKey: 'score',
          min: 0,
          max: 100,
          tickInterval: 20,
          nice: false,
        }];
      },
      // 柱状图
      histogramChart(arr, num) {
        this.chartDatahis = arr;
        this.chartNumhis = num;
        this.scale = [{
          dataKey: 'name',
          min: 0,
        }, {
          dataKey: 'score',
          min: 0,
          // max: 1,
        }];
        this.plotBackground = {
          fill: '#fff',
          radius: 5
        };

        this.axis1Opts = {
          dataKey: 'name',
          line: null,
          tickLine: null,
          label: {
            textStyle: {
              fill: '#333',
              fontSize: 12,
            },
            autoRotate: true
          }
        };
        this.axis2Opts = {
          dataKey: 'score',
          line: null,
          tickLine: null,
          label: {
            textStyle: {
              fill: '#333',
              fontSize: 12,
            },
            autoRotate: true
          }
        };

      },
      // 折线图
      lineChar(arr) {
        this.chartDataline = arr;
        this.scale = [{
          dataKey: 'name',
          min: 0,
        }, {
          dataKey: 'score',
          min: 0,
          // max: 1,
        }];
        this.plotBackground = {
          fill: '#fff',
          radius: 5
        };

        this.axis1Opts = {
          dataKey: 'name',
          line: null,
          tickLine: null,
          label: {
            textStyle: {
              fill: '#333',
              fontSize: 12,
            },
            autoRotate: true
          }
        };
        this.axis2Opts = {
          dataKey: 'score',
          line: null,
          tickLine: null,
          label: {
            textStyle: {
              fill: '#333',
              fontSize: 12,
            },
            autoRotate: true
          }
        };
      },
      // 雷达图
      radarChart(arr) {
        this.plotBackground = {
          fill: '#fff',
          radius: 5
        };

        this.scale = [{
          dataKey: 'score',
          min: 0,
          // max: 80,
        }];

        this.axis1Opts = {
          dataKey: 'name',
          line: null,
          tickLine: null,
          grid: {
            lineStyle: {
              lineDash: null
            },
            hideFirstLine: false,
          }
        };
        this.axis2Opts = {
          dataKey: 'score',
          line: null,
          tickLine: null,
          grid: {
            type: 'polar',
            lineStyle: {
              lineDash: null,
            },
          },
        };
      },
      // 条形图
      barChart() {
        this.label = {
          offset: 12,
          textStyle: {
            fill: '#333',
            fontSize: 12,
          },
          autoRotate: true
        };
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss">
@import "@s/remChange.scss";
.dimension_bg {
  background: url(../../../assets/dema_bg.png) no-repeat top center;
  background-size: cover;
  width: 100%;
  height: 630px;
}

.dimension {
  margin: 0 auto;
  height: 510px;
  margin: 30px auto;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  position: relative;
}

.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #F57F17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

.cep61_top {
  width: 100%;
  background: url(../../../assets/cep_t.png) no-repeat top center;
  background-size: cover;
  height: 470px;
  padding: 0 30px;
  padding-top: 72px;
  color: #2A877F;
  h1 {
    font-size: 50px;
    font-weight: bold;
    border-bottom: 8px solid #2A877F;
    padding-bottom: 10px;
    display: inline-block;
  }
  h2 {
    font-size: 26px;
    margin-top: 30px;
  }
  h3 {
    font-size: 20px;
    margin-top: 20px;
  }
  a {
    display: block;
    margin-top: 40px;
    width: 240px;
    height: 55px;
    background: #2A877F;
    border-radius: 8px;
    font-size: 30px;
    color: #fff;
    line-height: 55px;
    text-align: center;
  }
}

.cep_main {
  width: 690px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 110px;
  box-shadow: 5px 10px 10px #ccc;
  padding-top: 0;
  padding-bottom: 60px;
  text-align: center;
  .h_spe {
    width: 179px;
    height: 46px;
    background: rgba(46, 182, 168, 1);
    border-radius: 0px 23px 23px 0px;
    line-height: 46px;
    text-align: center;
    font-size: 28px;
    color: #fff;
  }
  .h_p {
    width: 598px;
    text-align: justify;
    color: #333;
    font-size: 26px;
    line-height: 50px;
    margin: 0 auto;
    margin-top: 40px;
  }
  .h_1 {
    width: 590px;
    height: 74px;
    background: rgba(46, 182, 168, 1);
    border-radius: 37px;
    line-height: 74px;
    color: #fff;
    font-size: 38px;
    margin: 0 auto;
    top: -37px;
    text-align: center;
    position: relative;
  }
  .h_2 {
    color: #2EB6A8;
    font-size: 32px;
    margin-top: 40px;
    margin-left: 20px;
    text-align: left;
    span {
      display: inline-block;
      width: 6px;
      height: 30px;
      background: rgba(46, 182, 168, 1);
      border-radius: 3px;
      margin-right: 20px;
      vertical-align: middle;
    }
  }
  .h_3 {
    font-size: 28px;
    color: #333;
    font-weight: bold;
    margin: 0 46px;
    margin-top: 80px;
    text-align: left;
  }
  .h_img {
    width: 598px;
    margin: 0 auto;
    margin-top: 40px;
  }
  .h_results {
    width: 598px;
    height: 188px;
    background: rgba(245, 253, 252, 1);
    margin: 0 auto;
    padding: 0 20px;
    border-top: 8px solid #2EB6A8;
    h2 {
      color: #333;
      font-size: 26px;
      margin-top: 40px;
      text-align: left;
      line-height: 24px;
      span {
        font-size: 32px;
        color: #2EB6A8
      }
    }
  }
}

.cep_main:first-child {
  padding-top: 24px;
  margin-top: 60px;
}
</style>
